import React from "react";

export const Posters=(props)=>
{
    return(
        <div id="posters">
            <div className="col-md-10 col-md-offset-1 section-title text-center">
               <h2>Posters</h2>
            </div>
            <div class="updatess">
            <img src="img/posters/IMG-20241129-WA0063.jpg" alt="" />
            <img src="img/posters/IMG-20241125-WA0084.jpg" alt="" />
            <img src="img/posters/IMG-20241124-WA0002.jpg" alt="" />
            <img src="img/posters/IMG-20241123-WA0041.jpg" alt="" />
            <img src="img/posters/IMG-20241123-WA0040.jpg" alt="" />
            <img src="img/posters/IMG-20241123-WA0038.jpg" alt="" />
            <img src="img/posters/IMG-20241120-WA0010.jpg" alt="" />
            <img src="img/posters/IMG-20241119-WA0051.jpg" alt="" />
            <img src="img/posters/IMG-20241116-WA0076.jpg" alt="" />
            <img src="img/posters/IMG-20241116-WA0029.jpg" alt="" />
            <img src="img/posters/IMG-20241115-WA0027.jpg" alt="" />
            <img src="img/posters/IMG-20241114-WA0103(1).jpg" alt="" />
            <img src="img/posters/IMG-20241114-WA0042.jpg" alt="" />
            <img src="img/posters/IMG-20241104-WA0031.jpg" alt="" />
            <img src="img/posters/IMG-20241101-WA0018(1).jpg" alt="" />
            <img src="img/posters/h4g PV-2.png" alt="" />
            <img src="img/posters/h4g cm sn.jpg" alt="" />
            <img src="img/posters/h4g $.jpg" alt="" />


            </div>
      
    </div>
    );
}